import TextField, { TextFieldProps } from '@mui/material/TextField'
import { NumericFormat, NumericFormatProps } from 'react-number-format'
import { ReadonlyTextField } from 'text_field'

type FormatWithoutSize = Omit<NumericFormatProps, 'size'>

export const TextInputNumber = (props: TextFieldProps & FormatWithoutSize) => {
  if (props.readOnly) {
    return <ReadonlyTextField sx={props.sx} label={props.label} value={props.value as string} />
  }

  return (
    <NumericFormat
      isAllowed={(num) => num.floatValue === undefined || num.floatValue <= Number.MAX_SAFE_INTEGER}
      {...props}
      decimalScale={0}
      allowNegative={false}
      allowLeadingZeros={false}
      type="text"
      customInput={TextField}
      valueIsNumericString={true}
    />
  )
}
